"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTerminator = exports.isIdent = exports.isNumber = exports.isAlpha = exports.isWhitespace = exports.isNewLine = void 0;
const constants_1 = require("./constants");
function isNewLine(c) {
    return c === '\r' || c === '\n';
}
exports.isNewLine = isNewLine;
function isWhitespace(c) {
    return c === ' ' || c === '\t' || c === '\n';
}
exports.isWhitespace = isWhitespace;
function isAlpha(c) {
    return !!c.match(/[a-z]/i);
}
exports.isAlpha = isAlpha;
function isNumber(c) {
    if (c === constants_1.EOS_FLAG) {
        return false;
    }
    return !isNaN(parseFloat(c)) && isFinite(parseInt(c, 10));
}
exports.isNumber = isNumber;
function isIdent(c) {
    if (c === constants_1.EOS_FLAG) {
        return false;
    }
    return isAlpha(c) || isNumber(c) || c === '_' || c === '-' || c === '\\';
}
exports.isIdent = isIdent;
function isTerminator(c) {
    return c === constants_1.EOS_FLAG || isWhitespace(c) || c === ',' || c === ']' || c === ')';
}
exports.isTerminator = isTerminator;
//# sourceMappingURL=strings.js.map